<script>
import { mapState, mapActions } from 'vuex';
import dateMixin from '../../mixins/dateMixin';

export default {
  name: 'JobDataTable',
  mixins: [
    dateMixin,
  ],
  data() {
    return {
      headers: [
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Sub channel', value: 'subChannel', sortable: false },
        { text: 'Start time', value: 'startTime', sortable: false },
        { text: 'EndTime', value: 'system', sortable: false },
        { text: 'Run time', value: 'runTime', sortable: false },
        { text: 'Rows', value: 'rows', sortable: false },
        { text: 'Action', value: 'action', align: 'right', sortable: false },
      ],
    };
  },
  methods: {
    ...mapActions({
      selectType: 'prices/selectType',
    }),
    getSubChannelName(id) {
      if (id === null) {
        return 'None';
      }
      const selectedChannel = this.filter.channel;
      const subChannel = selectedChannel.subChannels.find(obj => obj.id === id);
      return subChannel ? subChannel.name : 'None';
    },
    getStatusChip(sts) {
      let returnValue = '';
      const status = sts.toLowerCase();
      switch (status) {
        case 'error':
          returnValue = { color: 'error', label: status };
          break;
        case 'warning':
          returnValue = { color: 'warning', label: status };
          break;
        case 'success':
          returnValue = { color: 'success', label: status };
          break;
        default:
          returnValue = { color: 'light-blue', label: status };
      }
      return returnValue;
    },
  },
  computed: {
    ...mapState({
      jobs: state => state.prices.jobs,
      channels: state => state.prices.channels,
      list: state => state.prices.list,
      filter: state => state.prices.filter,
    }),
    getStatusMessage() {
      if (this.list.error) {
        return this.list.errorMessage;
      }
      return !this.list.noContent
        ? 'Search for prices by using the filter'
        : 'No content were found with that filter';
    },
  },
};
</script>

<template>
  <v-data-table
    :headers="headers"
    :items="jobs.items"
    :loading="list.loading"
    class="elevation-1"
    hide-actions
  >
    <template v-slot:no-data>
      <tr>
        <td v-if="!list.loading"
            :colspan="headers.length"
            class="text-xs-center"
        >
          {{ getStatusMessage }}
        </td>
        <td v-if="list.loading" :colspan="headers.length" class="text-xs-center">Searching...</td>
      </tr>
    </template>
    <template v-if="!list.loading" v-slot:items="job">
      <td>
        <v-chip
          :color="getStatusChip(job.item.status).color"
          text-color="white"
        >
          {{ getStatusChip(job.item.status).label }}
        </v-chip>
      </td>
      <td>{{ getSubChannelName(job.item.subChannelId) }}</td>
      <td>{{ formatDate(job.item.runStart, 'No date') }}</td>
      <td>{{ formatDate(job.item.runEnd, 'No date') }}</td>
      <td>{{ getFormattedDuration(job.item.runStart, job.item.runEnd, 'duration') }}</td>
      <td>{{ job.item.rows }}</td>
      <td align="right">
        <v-btn
          v-if="!job.item.hasStockRemoved"
          @click="selectType({type: 'import', id: job.item.id})"
          color="primary"
          outline
        >
          Select
        </v-btn>
      </td>
    </template>
  </v-data-table>
</template>



// WEBPACK FOOTER //
// src/components/prices/JobDataTable.vue